'use strict'

const { isProductHttpsHost } = require('./public-host')

function isLocalDev (env) {

  const source = env || process.env
  const nodeEnv = String(source.NODE_ENV || '').trim().toLowerCase()
  const named = String(source.SUPERTURBO_ENV || '').trim().toLowerCase()
  const dev = new Set(['', 'dev', 'development', 'test', 'local'])

  return dev.has(nodeEnv) && dev.has(named)
}

function isAllowedOrigin (origin, env) {

  if (!origin || typeof origin !== 'string') return false

  let parsed

  try {

    parsed = new URL(origin)
  } catch (error) {

    return false
  }

  if (!isLocalDev(env)) {

    return parsed.protocol === 'https:' && isProductHttpsHost(parsed.hostname, env)
  }

  const url = parsed

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false

  const host = url.hostname.toLowerCase()

  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost')
}

module.exports = {
  isLocalDev,
  isAllowedOrigin
}
